<script setup lang="ts">
import { storeToRefs } from 'pinia'
import type { ComputedRef } from 'vue'
import { useEspacoEventoStore } from './store/useEspacoEventoStore'
import type { IEspacoEvento } from './types'
import type { IHeader, ITableAction } from '@/pages/types/layoutTable.types'
import type { ITerm } from '@/components/CDF/SearchBar.vue'
import LayoutTable from '@/components/CDF/LayoutTable.vue'

withDefaults(defineProps<{
  isHeader: boolean
}>(), {
  isHeader: true,
})

definePage({
  meta: {
    action: 'list',
    subject: 'espaco-evento',
  },
})

const store = useEspacoEventoStore()

const {
  items,
  itemsPerPage,
  page,
  loading,
  searchTerm,
  isSearching,
} = storeToRefs(store)

const {
  loadMore,
  search: onSearch,
  searchAgain: onSearchAgain,
  resetSearch,
  destroy,
  onOrderBy,
  dialogDestroy,
} = store

const headers: ComputedRef<IHeader[]> = computed(() => {
  return [
    {
      title: 'Nome',
      key: 'nome',
    },
    {
      title: 'Tamanho M2',
      key: 'tamanho_m2',
    },
    {
      title: 'Capacidade',
      key: 'capacidade',
    },
  ]
})

const terms: ComputedRef<ITerm[]> = computed(() => {
  return [
    {
      title: 'Nome',
      value: 'nome',
    },
    {
      title: 'Tamanho M2',
      value: 'tamanho_m2',
    },
    {
      title: 'Capacidade',
      value: 'capacidade',
    },
  ]
})

const actions: ITableAction[] = [
  {
    icon: 'tabler-edit',
    color: 'primary',
    can: {
      action: 'edit',
      subject: 'espaco-evento',
    },
    to: (item: IEspacoEvento) => `/admin/espaco-evento/editar/${item.id}`,
  },
  {
    icon: 'tabler-trash',
    color: 'error',
    can: {
      action: 'delete',
      subject: 'espaco-evento',
    },
    onClick: (item: IEspacoEvento) => dialogDestroy(item.id),
  },
]

onBeforeRouteLeave(() => {
  store.$reset()
})
</script>

<template>
  <LayoutTable
    v-model:items="items"
    v-model:loading="loading.items"
    v-model:loading-destroy="loading.destroy"
    v-model:search="searchTerm"
    v-model:is-searching="isSearching"
    :destroy="destroy"
    :is-header="isHeader"
    title="Espaco Eventos"

    new-item="/admin/espaco-evento/cadastrar"
    :headers="headers"
    :actions="actions"
    :items-per-page="itemsPerPage"
    :page="page"

    :load-more="loadMore"
    :terms-search="terms"
    :on-search="onSearch"
    :on-search-again="onSearchAgain"
    :on-reset="resetSearch"
    :on-order-by="onOrderBy"
  />
</template>
